import React, { Component } from 'react'
import axios from "axios"

export class ToInProcessModal extends Component {

    state = {
        onholdMessage: ""
    }


    handleMultipleOnHold = (e) => {
        // e.preventDefault()
        for (let i = 0; i < this.props.crfToUpdate.length; i++) {
            axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/onHold/${this.props.crfToUpdate[i]}`,
                data: {
                  reason:this.state.onholdMessage
                },
                headers: {
                  'Api-Key':
                    '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`
                }
              })
                .then(response => {
                    
                  if(response.data.data.nModified === 1){
                    window.location.reload()
                  }
              })
              .catch(error => {
                    
                })
        }
       
      }

      handleOnHoldMessage = (e) => {
          this.setState({
              onholdMessage: e.target.value
          })
      }

     
    render() {  

        return (
            <div id="modalBody" className="modalBody">
                <div className="modalContainer" >
                    <div className="modalbg">
                        <div id="modalContentDashboard">
                            <h3 className="toOnHoldModalHead">In Process</h3>
                            <div className="modalInputForEndorsement">
                                <h5 className="messageHead">Message:</h5>
                                <textarea onChange={this.handleOnHoldMessage} type="text" className="onHoldMessageInput" rows="4" cols="50"/>
                            </div>
                            <div className="toOnHoldBtnGroup">
                                <button className="toOnholdBulkBtn" onClick={this.handleMultipleOnHold}>In Process</button>
                                <button className="toOnholdCloseBulkBtn" onClick={this.props.handleCloseModal}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const textRed = {
    color: "red"
}

export default ToInProcessModal
